import { NextPage } from 'next';

import { HeaderContactUs } from './components/HeaderContactUs/HeaderContactUs';
import { useIntl } from '@klokhuis/core/Intl';
import { PageLayout } from '@klokhuis/core/PageLayout';
import { ROUTES } from '@klokhuis/core/Routing';

const ContactUs: NextPage = () => {
  const { T } = useIntl();

  return (
    <PageLayout
      pageTitle={T('CONTACT_US_PAGE_TITLE')}
      metaDescription={T('CONTACT_US_PAGE_METADATA')}
      route={ROUTES.Home}
      showPropertyLinksGrid={false}
    >
      <PageLayout.MainRaw>
        <HeaderContactUs />
      </PageLayout.MainRaw>
    </PageLayout>
  );
};

export default ContactUs;
